import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const PricingFAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How long does implementation take?",
      answer: "The implementation process typically takes up to 2 weeks, depending on your firm's specific needs and system setup."
    },
    {
      question: "What support is included, and are there additional services?",
      answer: "Each plan ensures that your dashboard stays up and running every day. Additional on-demand support, upgrades, or custom developments are available at an extra cost."
    },
    {
      question: "Are there any long-term commitments or contracts?",
      answer: "No, we don't require long-term commitments or contracts. You can cancel your subscription at any time without penalties."
    },
    {
      question: "Is there an implementation fee?",
      answer: "Yes, there is a one-time implementation fee of $500. This covers the setup and integration of the add-on into your existing system."
    },
    {
      question: "Is there a refund policy?",
      answer: "Unfortunately, refunds are not allowed. Once a payment is processed, it is non-refundable."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Frequently Asked Questions
          </h2>
        </div>
        
        <div className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <button
                className="w-full px-4 sm:px-6 py-3 sm:py-4 text-left focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-inset hover:bg-gray-50 transition-colors min-h-[44px]"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 pr-3 sm:pr-4">
                    {faq.question}
                  </h3>
                  <div className="flex-shrink-0">
                    {openIndex === index ? (
                      <ChevronUp className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
                    ) : (
                      <ChevronDown className="w-4 h-4 sm:w-5 sm:h-5 text-gray-500" />
                    )}
                  </div>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-4 sm:px-6 pb-3 sm:pb-4 border-t border-gray-100">
                  <p className="text-sm sm:text-base text-gray-700 leading-relaxed pt-3 sm:pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingFAQSection;